<template>
    <div class="hykecam-camera-area" ref="hykeCamCameraArea">
        <div class="hykecam-center" :style="{ height: hykeCamHeightPx }">
            <video ref="hykeCamVideo" class="media-video-player card-video vjs-big-play-centered hykecam-video" autoplay
                @click="hykeCamScreen" />
        </div>
        <div class="loader" v-show="hykeCamLoaderShow"
            :style="{ width: hykeCamLoaderWidthPx, height: hykeCamLoaderHeightPx, top: hykeCamLoaderTopPx, left: hykeCamLoaderLeftPx }">
        </div>
    </div>
</template>

<script>
export default {
    name: "HykeCameraView",
    props: {
        hykeCamHeightPx: String,
        hykeCamLoaderShow: Boolean,
        hykeCamLoaderWidthPx: String,
        hykeCamLoaderHeightPx: String,
        hykeCamLoaderTopPx: String,
        hykeCamLoaderLeftPx: String,
        hykeCamScreen: Function
    }
};
</script>